import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { AppConfigService, HanhChinhService, QueryThuaDat, SearchController, TabIndex, ToaDo } from 'lib';
import {
  PhuongXaEntity, QuanHuyenEntity
} from 'lib/models/hanh-chanh.interface';
import { finalize } from 'rxjs/operators';
import { SharedService } from '../../../../shared/shared.service';

@Component({
  selector: 'web-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent extends SearchController implements OnInit {
  quanHuyens: QuanHuyenEntity[] = [];
  phuongXas: PhuongXaEntity[] = [];
  showSpinner = false;
  constructor(
    private hanhChinhService: HanhChinhService,
    private service: SharedService,
    private notifierService: NotifierService,
    private configService: AppConfigService,
  ) {
    super();
  }

  ngOnInit() {
    this.tabIndex = TabIndex.ToThua;
    this.configService.getApp().subscribe((config) => {
      this.lstCoords = (config.map.defaultLstCoords as Array<ToaDo>).map(
        (m) => {
          // tslint:disable-next-line: no-string-literal
          m['isValid'] = this.isValidCoord(m);
          return m;
        },
      );
    });
    this.hanhChinhService
      .getMany({
        fields: ['maQuanHuyen', 'tenQuanHuyen'] as Array<keyof QuanHuyenEntity>,
      })
      .subscribe((val) => (this.quanHuyens = val));
  }

  async handleChange(name: string, value: any) {
    this.notifierService.hide('is-valid');
    // nếu là quận huyện thì cập nhật phường/xã
    if (name === 'maQuanHuyen') {
      this.soToSoThua.maPhuongXa = undefined; // reset phường xã
      // nếu có giá trị thì request
      if (value) {
        // goto
        this.showSpinner = true;
        this.hanhChinhService
          .getOne(value, {
            join: [
              {
                field: 'phuongXas',
                select: ['maPhuongXa', 'tenPhuongXa'] as Array<
                  keyof PhuongXaEntity
                >,
              },
            ],
          })
          .pipe(finalize(() => (this.showSpinner = false)))
          .subscribe((s) => (this.phuongXas = s.phuongXas));
      } else {
        // không có thì reset phường/xã
        this.phuongXas = [];
      }
      this.hanhChinhService.goTo({ maQuanHuyen: value });
    } else if (name === 'maPhuongXa') {
      this.hanhChinhService.goTo({ maPhuongXa: value });
    }
  }

  /**
   * Xóa dòng tọa độ
   * @param index: Số thứ tự cần xóa
   */
  handleRemoveCoords(index: number) {
    const result = super.handleRemoveCoords(index);
    if (result > -1) {
      // vẽ lại graphics
      this.drawGraphicByCoords();
    }
    return result;
  }

  async handleOnChangeInputCoord(
    value,
    index: number,
    type: 'toaDoX' | 'toaDoY',
  ) {
    const result = super.handleOnChangeInputCoord(value, index, type);
    if (result) {
      this.drawGraphicByCoords();
    }
    return result;
  }

  private drawGraphicByCoords() {
    this.service.drawGraphicByCoords({
      toaDos: this.lstCoords.filter(this.isValidCoord),
    });
  }

  async handleSearch() {
    if (this.isValid()) {
      if (this.tabIndex === TabIndex.ToThua) {
        this.service.layThongTinQuyHoach({
          thuaDat: this.soToSoThua as QueryThuaDat,
        });
      } else if (this.tabIndex === TabIndex.ToaDo) {
        this.service.layThongTinQuyHoach({
          toaDos: this.lstCoords.filter(this.isValidCoord),
        });
      }
    } else {
      this.notifierService.hide('is-valid');
      this.notifierService.notify(
        'warning',
        'Vui lòng nhập đầy đủ thông tin',
        'is-valid',
      );
    }
  }

  toThuaClick() {
    this.tabIndex = TabIndex.ToThua;
  }
  toaDoClick() {
    this.tabIndex = TabIndex.ToaDo;
  }
}
